import type { TwoColumnTextBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { cx } from 'cva'
import { CMSBlocks } from '../atoms/CMSBlocks'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

type TwoColumnTextLayout = TwoColumnTextBlock['layout']

const columnClassesMap: Record<TwoColumnTextLayout, { left: string; right: string }> = {
	'5-1-6': {
		left: cx([
			'col-span-full',
			'layout-narrow:tablet-l:col-span-4',
			'layout-wide:tablet-l:col-span-5',
		]),
		right: cx([
			'col-span-full',
			'layout-narrow:tablet-l:col-span-4',
			'layout-wide:tablet-l:col-span-6 layout-wide:tablet-l:col-start-7',
		]),
	},
	'6-1-5': {
		left: cx([
			'col-span-full',
			'layout-narrow:tablet-l:col-span-4',
			'layout-wide:tablet-l:col-span-6',
		]),
		right: cx([
			'col-span-full',
			'layout-narrow:tablet-l:col-span-4',
			'layout-wide:tablet-l:col-span-5 layout-wide:tablet-l:col-start-8',
		]),
	},
}

export const TwoColumnTextConverter: JSXConverter<SerializedBlockNode<TwoColumnTextBlock>> = ({
	node,
	nodesToJSX,
}) => {
	const { layout, left, right, blockTypes } = node.fields
	const classes = columnClassesMap[layout]
	return (
		<ContentBlockWrapper blockTypes={blockTypes} gridClassName="gap-y-2xl" layout="nested">
			<CMSBlocks className={classes.left}>
				{nodesToJSX({ nodes: left?.root?.children ?? [] })}
			</CMSBlocks>
			<CMSBlocks className={classes.right}>
				{nodesToJSX({ nodes: right?.root?.children ?? [] })}
			</CMSBlocks>
		</ContentBlockWrapper>
	)
}
